import { type UseQueryResult, useQuery } from 'react-query';
import { VendorTermsAndConditionsService } from '../../services/wealthlane-customer-services';

const useGetVendorOverrideTnC = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const VendorOverrideTnCList = useQuery(
    ['getVendorOverrideTnCList'],
    async () => {
      return await handleRequest(
        VendorTermsAndConditionsService.getApiCustomerApiVendorTermsAndConditionsBrokers()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.text ?? '',
            value: item.value ?? '',
            disabled: item.disabled ?? false,
            group: item.group ?? null,
            selected: item.selected ?? false,
          };
        });
      },
    }
  );

  return VendorOverrideTnCList;
};

export default useGetVendorOverrideTnC;
